import { InventoryLocationBuilding, SerializedInventoryLocationBuilding } from '@enmon/commons/lib/tools';
import { Authenticator } from 'services/httpClient';
import { StrapiApiResponse } from 'types/strapiResponse';
import { Populate, buildQuery } from '@enmon/commons/lib/tools/utils/buildQuery';
import { BaseApiClient } from './baseApiClient';

export interface FindInventoryLocationBuildingArgs {
  filter?: InventoryLocationBuildingsFilter;
  populate?: Populate<SerializedInventoryLocationBuilding>;
  signal?: AbortSignal;
}

export type FindInventoryLocationBuildingResponse = StrapiApiResponse<SerializedInventoryLocationBuilding>;

export interface InventoryLocationBuildingsFilter {
  id?: InventoryLocationBuilding['id'];
  ids?: InventoryLocationBuilding['id'][];
}

export class InventoryLocationBuildingsApiClient extends BaseApiClient<InventoryLocationBuilding> {
  constructor(authenticator: Authenticator | undefined) {
    super('inventory-location-buildings', authenticator);
  }

  async find({
    filter = {},
    populate = {},
    signal,
  }: FindInventoryLocationBuildingArgs): Promise<FindInventoryLocationBuildingResponse> {
    const { id, ids } = filter;

    return await this.http.get<FindInventoryLocationBuildingResponse>('', {
      params: buildQuery<SerializedInventoryLocationBuilding>({
        sort: {
          name: 'asc',
        },
        filters: {
          ...(id ? { id: { $eq: id } } : {}),
          ...(ids ? { id: { $in: ids } } : {}),
        },
        populate,
      }),
      signal,
    });
  }
}
